import uniqueId from 'lodash/uniqueId';
import { useCallback, useState } from 'react';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import { ebGlobalChannel } from 'src/lib/events-bridge';
import useSubscription from 'src/lib/events-bridge/hooks/useSubscription';
import EBAPIs from 'src/lib/events-bridge/topics';
export function resolveAnchorEl(ref) {
    return ref;
}
export default function usePopover() {
    const [state, setState] = useState({
        visible: false,
        anchorEl: null,
        component: null,
    });
    const show = useCallback((popoverData) => {
        setState({
            ...popoverData,
            visible: true,
        });
    }, []);
    const hide = useCallbackWithCtx((ctx, id) => {
        if (typeof id === 'string') {
            if (ctx.state.id !== id) {
                return;
            }
        }
        ctx.state.onClose?.();
        setState(prevState => ({
            ...prevState,
            visible: false,
        }));
    }, { state });
    useSubscription(EBAPIs.helperViews.popover.show, show);
    useSubscription(EBAPIs.helperViews.popover.hide, hide);
    const actions = {
        show,
        hide,
    };
    return [state, actions];
}
export const popoverHelperActions = {
    show(data) {
        ebGlobalChannel.publish(EBAPIs.helperViews.popover.show, {
            ...data,
            id: data.id ?? uniqueId(),
        });
    },
    hide(id) {
        ebGlobalChannel.publish(EBAPIs.helperViews.popover.hide, id);
    },
};
